import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Radio from "@mui/material/Radio";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { makeStyles } from "@material-ui/core/styles";
import CircleIcon from "@mui/icons-material/Circle";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import RecordButtonOpen from "../../Components/Media/RecordButtonOpen";
import SmartCheckCardOpen from "../../Components/Card/AssetUI/SmartCheckCardOpen";
import AITestGuestInfo from "../../Components/Modal/AITestGuestInfo";
import { userLogs } from "../../Js/Common";
import uuid from "react-uuid";
import html2pdf from "html2pdf.js";
import { twoDigit } from "../../Js/TimeAndDate";
import { updateLog } from "./Services";
import TimerIcon from "@mui/icons-material/Timer";

const AITestReportView = (props) => {
  const navigation = useNavigate();
  const classes = useStyles();
  let [userAnswer, setUserAnswer] = useState([]);
  let [localAudios, setLocalAudios] = useState([]);
  let [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  let [smartCheckResult, setSmartCheckResult] = useState([]);
  let [isPlaying, setIsPlaying] = useState(false);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  let [unscripted, setUnscripted] = useState(true);
  let [currentRecord, setCurrentRecord] = useState(false);
  let [aiEnable, setAiEnable] = useState(true);
  let [infoModl, setInfoModl] = useState(true);
  let [savedLogId, setSavedLogId] = useState(null);
  let [userData, setUserData] = useState({});
  let [timerClock, setTimerClock] = useState(30);
  let [interval1, setInterval1] = useState(null);
  let [hidePronoun, setHidePronoun] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("smartcheck") && localStorage.getItem("info")) {
      setSmartCheckResult(JSON.parse(localStorage.getItem("smartcheck")));
      setUserData(JSON.parse(localStorage.getItem("info")));
    }
  }, [localStorage]);

  const downloadPDF = () => {
    if (
      smartCheckResult &&
      smartCheckResult.length > 0 &&
      smartCheckResult[0] &&
      aiEnable
    ) {
      var element = document.getElementById("pdfid");
      var opt = {
        margin: [20, 15, 0, 0],
        filename: `report_${userData.name}.pdf`,
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "landscape",
        },
      };
      //html2pdf(element,opt);
      html2pdf().from(element).set(opt).toPdf().save();
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: "url(./mainbackground.svg)",
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <Grid container>
        <Box
           
          sx={{
            backgroundColor: "#FFFFFF",
            margin: 2,
            height: "90vh",
            borderRadius: 5,
            boxShadow: 10,
            padding: 2,
            overflow: "auto",
          }}
        >
          <Grid container sx={{ mt: 4 }}>
            <Grid item md={12} sm={12}>
              {/* <Box sx={{ textAlign: "center" }}>
                <img
                  src="/words_full.png"
                  alt="Vocablab"
                  loading="lazy"
                  width="12%"
                />
                <Typography className={classes.className1} sx={{}}>
                  <b>Linguistic Insight Engine</b>
                </Typography>
                <Typography className={classes.className} sx={{}}>
                  <b>Assessment for English Language Proficiency</b>
                </Typography>
              </Box> */}
              <Box sx={{ textAlign: "center" }} id="pdfid">
                {smartCheckResult &&
                  smartCheckResult.length > 0 &&
                  smartCheckResult[0] &&
                  aiEnable && (
                    <Grid container sx={{ pa: 0, width: "100%" }}>
                      <SmartCheckCardOpen
                        smartCheckResult={smartCheckResult[0]}
                        unscripted={unscripted}
                        name={userData.name}
                        schoolName={userData.schoolName}
                        email={userData.email}
                        hidePronoun={hidePronoun}
                      ></SmartCheckCardOpen>
                    </Grid>
                  )}
              </Box>
              {smartCheckResult &&
                smartCheckResult.length > 0 &&
                smartCheckResult[0] &&
                aiEnable && (
                  <Box sx={{ textAlign: "center" }}>
                    <div style={{ marginTop: "2rem" }}>
                      <Button
                        variant="contained"
                        size="large"
                        sx={{ fontSize: "1.2rem", fontWeight: "bold", mx: 1 }}
                        startIcon={<DownloadIcon />}
                        onClick={() => {
                          setHidePronoun(true);
                          setTimeout(() => {
                            setHidePronoun(false);
                          }, 2000);
                          downloadPDF();
                        }}
                      >
                        Download Your Report
                      </Button>
                      {/* <Button
                    variant="contained"
                    size="large"
                    sx={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      mx: 2,
                      px: 6,
                    }}
                    startIcon={<PrintIcon />}
                  >
                    Print
                  </Button> */}
                    </div>
                  </Box>
                )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  card: {
    // backgroundColor: "#fff",
    // width: '32rem',
    // height: '36rem',
    borderRadius: 17,
    // shadowColor: "#000",
    // boxShadow: "2rem",
    textAlign: "center",
  },
  ModuleNum: {
    textAlign: "center",
    fontWeight: "900",
    color: "#DB8829",
    fontSize: "3rem",
    marginTop: "2%",
  },
  ModuleName: {
    fontSize: "1.4rem",
    textAlign: "center",
    fontWeight: "600",
    paddingBottom: 10,
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    paddingTop: 10,
    fontWeight: "500",
  },
  className1: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.8rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
    marginTop: "2%",
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.2rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
    marginTop: "2%",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
   
  },
});

export default AITestReportView;
